import React from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  onClick?: () => void;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  iconBgColor = '#E3F2FD',
  iconColor = '#1976D2',
  trend,
  onClick,
}) => {
  return (
    <div
      className={`bg-white rounded-lg p-5 shadow-sm transition-all ${onClick ? 'cursor-pointer hover:shadow-md' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3">
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: iconBgColor }}
        >
          <div className="w-5 h-5" style={{ color: iconColor }}>
            {icon}
          </div>
        </div>
        {subtitle && (
          <span className="text-xs px-2 py-1 rounded" style={{ backgroundColor: '#F3F4F6', color: '#6B7280' }}>
            {subtitle}
          </span>
        )}
      </div>
      <p className="text-sm font-medium mb-1" style={{ color: '#6B7280' }}>
        {title}
      </p>
      <div className="flex items-end gap-2">
        <h3 className="text-2xl font-bold" style={{ color: '#1F2937' }}>
          {value}
        </h3>
        {trend && (
          <span
            className="text-xs font-medium mb-1"
            style={{ color: trend.isPositive ? '#10B981' : '#EF4444' }}
          >
            {trend.value}
          </span>
        )}
      </div>
    </div>
  );
};

